import { useCallback } from 'react'
import type { ApplicationFormState, FieldErrorKey, UpdateApplicationField } from '../../types'
import type { UpdateEnrollmentDraft } from '../../utils/draftPersistence'

type UseApplicationFormSelectionActionsArgs = {
  clearFieldError: (field: FieldErrorKey) => void
  state: ApplicationFormState
  updateEnrollmentDraft: UpdateEnrollmentDraft
  updateField: UpdateApplicationField
}

export function useApplicationFormSelectionActions({
  clearFieldError,
  updateEnrollmentDraft,
  updateField
}: UseApplicationFormSelectionActionsArgs) {
  const handleTermsAcceptedChange = useCallback(
    (value: boolean) => {
      updateField('termsAccepted', value)
      updateField('smsConsent', value)
      updateEnrollmentDraft({
        termsAccepted: value,
        marketingConsent: value,
        smsConsent: value
      })
      clearFieldError('termsAccepted')
    },
    [clearFieldError, updateEnrollmentDraft, updateField]
  )

  return {
    handleTermsAcceptedChange
  }
}
